import { defineMessages } from 'react-intl';

/** The words of the block picker (design b1–b5, c6). Benefit-first copy. */
export const pickerMessages = defineMessages({
  title: { id: 'app.sml.smartlinks.editor.picker.title', defaultMessage: 'Add a block' },
  subAfter: {
    id: 'app.sml.smartlinks.editor.picker.sub_after',
    defaultMessage: 'It goes under {name}. You can move it later.',
  },
  subEnd: { id: 'app.sml.smartlinks.editor.picker.sub_end', defaultMessage: 'It goes at the end of the page.' },
  subEndBio: {
    id: 'app.sml.smartlinks.editor.picker.sub_end_bio',
    defaultMessage: 'It goes at the end of your Bio Link.',
  },
  search: {
    id: 'app.sml.smartlinks.editor.picker.search',
    defaultMessage: 'Search blocks, for example video or merch',
  },
  results: {
    id: 'app.sml.smartlinks.editor.picker.results',
    defaultMessage: '{count, plural, one {# block} other {# blocks}}',
  },
  noMatch: { id: 'app.sml.smartlinks.editor.picker.no_match', defaultMessage: 'No block matches "{query}"' },
  noMatchHint: {
    id: 'app.sml.smartlinks.editor.picker.no_match_hint',
    defaultMessage:
      'A countdown is part of Catalog links: it shows before the release day. Try "pre-save", "video" or "link".',
  },
  showCatalogLinks: { id: 'app.sml.smartlinks.editor.picker.show_catalog_links', defaultMessage: 'Show Catalog links' },
  clearSearch: { id: 'app.sml.smartlinks.editor.picker.clear', defaultMessage: 'Clear the search' },
  chipAll: { id: 'app.sml.smartlinks.editor.picker.chip.all', defaultMessage: 'All' },
  groupMusic: { id: 'app.sml.smartlinks.editor.picker.group.music', defaultMessage: 'Music' },
  groupGrow: { id: 'app.sml.smartlinks.editor.picker.group.grow', defaultMessage: 'Grow your fans' },
  groupLinks: { id: 'app.sml.smartlinks.editor.picker.group.links', defaultMessage: 'Links, pictures and text' },
  groupAbout: { id: 'app.sml.smartlinks.editor.picker.group.about', defaultMessage: 'About you' },
  chipLinks: { id: 'app.sml.smartlinks.editor.picker.chip.links', defaultMessage: 'Links' },
  chipPictures: { id: 'app.sml.smartlinks.editor.picker.chip.pictures', defaultMessage: 'Pictures and text' },
  recommendedSong: {
    id: 'app.sml.smartlinks.editor.picker.recommended_song',
    defaultMessage: 'Recommended for a song page',
  },
  recommendedSongWhy: {
    id: 'app.sml.smartlinks.editor.picker.recommended_song_why',
    defaultMessage: 'The blocks that get the most clicks on song pages.',
  },
  recommendedBio: {
    id: 'app.sml.smartlinks.editor.picker.recommended_bio',
    defaultMessage: 'Recommended for your Bio Link',
  },
  recommendedBioWhy: {
    id: 'app.sml.smartlinks.editor.picker.recommended_bio_why',
    defaultMessage: 'One page for everything you do.',
  },
  alreadyOnBio: { id: 'app.sml.smartlinks.editor.picker.already_bio', defaultMessage: 'Already on your Bio Link' },
  onThisPage: { id: 'app.sml.smartlinks.editor.picker.on_page', defaultMessage: 'On this page' },
  onThisPageSong: { id: 'app.sml.smartlinks.editor.picker.on_page_song', defaultMessage: 'On this page · {title}' },
  newTag: { id: 'app.sml.smartlinks.editor.picker.new', defaultMessage: 'New' },
  // Block names and lines.
  catalogLinks: { id: 'app.sml.smartlinks.editor.picker.catalog_links', defaultMessage: 'Catalog links' },
  catalogLinksBio: {
    id: 'app.sml.smartlinks.editor.picker.catalog_links_bio',
    defaultMessage: 'Catalog links of a song',
  },
  catalogLinksLine: {
    id: 'app.sml.smartlinks.editor.picker.catalog_links_line',
    defaultMessage: 'Fans play the song on the service they use. Before release day, they pre-save it.',
  },
  catalogLinksLineFree: {
    id: 'app.sml.smartlinks.editor.picker.catalog_links_line_free',
    defaultMessage: 'Fans play the song on the service they use. Pre-save before release day is on {plan}.',
  },
  catalogLinksLineBio: {
    id: 'app.sml.smartlinks.editor.picker.catalog_links_line_bio',
    defaultMessage: 'Your newest song, playable on every service, right under your name.',
  },
  media: { id: 'app.sml.smartlinks.editor.picker.media', defaultMessage: 'Media' },
  mediaLine: {
    id: 'app.sml.smartlinks.editor.picker.media_line',
    defaultMessage: 'Your video or cover plays on the page and stops the scroll.',
  },
  player: { id: 'app.sml.smartlinks.editor.picker.player', defaultMessage: 'Player' },
  playerLine: {
    id: 'app.sml.smartlinks.editor.picker.player_line',
    defaultMessage: 'Fans hear the song before they leave your page. Also YouTube videos.',
  },
  subscribe: { id: 'app.sml.smartlinks.editor.picker.subscribe', defaultMessage: 'Get every release' },
  subscribeLine: {
    id: 'app.sml.smartlinks.editor.picker.subscribe_line',
    defaultMessage: "Every new song lands in your fans' libraries on release day.",
  },
  social: { id: 'app.sml.smartlinks.editor.picker.social', defaultMessage: 'Social links' },
  socialLine: {
    id: 'app.sml.smartlinks.editor.picker.social_line',
    defaultMessage: 'Fans follow you everywhere in one tap.',
  },
  link: { id: 'app.sml.smartlinks.editor.picker.link', defaultMessage: 'Link' },
  linkLine: {
    id: 'app.sml.smartlinks.editor.picker.link_line',
    defaultMessage: 'Send fans to your merch, tickets or any other page.',
  },
  text: { id: 'app.sml.smartlinks.editor.picker.text', defaultMessage: 'Text' },
  textLine: {
    id: 'app.sml.smartlinks.editor.picker.text_line',
    defaultMessage: 'Tell fans what is new, in your own words.',
  },
  profile: { id: 'app.sml.smartlinks.editor.picker.profile', defaultMessage: 'Profile' },
  profileLine: {
    id: 'app.sml.smartlinks.editor.picker.profile_line',
    defaultMessage: 'Fans see who is behind the music: name, photo and bio.',
  },
  // Defaults and errors of a new block.
  defaultText: { id: 'app.sml.smartlinks.editor.picker.default_text', defaultMessage: 'New single out now' },
  needsSong: {
    id: 'app.sml.smartlinks.editor.picker.needs_song',
    defaultMessage: 'Add a song to your Catalog first. Then add this block.',
  },
  needsSpotify: {
    id: 'app.sml.smartlinks.editor.picker.needs_spotify',
    defaultMessage: 'No song of your Catalog has a Spotify link yet. Add one on the song page first.',
  },
  needsAddress: {
    id: 'app.sml.smartlinks.editor.picker.needs_address',
    defaultMessage: 'Your artist address is not ready yet. Try again in a moment.',
  },
  addFailed: {
    id: 'app.sml.smartlinks.editor.picker.add_failed',
    defaultMessage: 'We could not add the block. Try again.',
  },
  // "Which song?" (c6).
  songTitle: { id: 'app.sml.smartlinks.editor.picker.song.title', defaultMessage: 'Which song?' },
  songSub: {
    id: 'app.sml.smartlinks.editor.picker.song.sub',
    defaultMessage: "The block shows this song's links and keeps them up to date.",
  },
  songSearch: { id: 'app.sml.smartlinks.editor.picker.song.search', defaultMessage: 'Search your Catalog' },
  songOfPage: { id: 'app.sml.smartlinks.editor.picker.song.of_page', defaultMessage: 'the song of this page' },
  songUpcoming: { id: 'app.sml.smartlinks.editor.picker.song.upcoming', defaultMessage: 'Upcoming' },
  songOut: { id: 'app.sml.smartlinks.editor.picker.song.out', defaultMessage: 'Out' },
  songNoDate: { id: 'app.sml.smartlinks.editor.picker.song.no_date', defaultMessage: 'No date' },
  songOnPage: { id: 'app.sml.smartlinks.editor.picker.song.on_page', defaultMessage: 'On this page' },
  songNotListed: {
    id: 'app.sml.smartlinks.editor.picker.song.not_listed',
    defaultMessage: 'Not in the list? Add it to your Catalog first.',
  },
  songAdd: { id: 'app.sml.smartlinks.editor.picker.song.add', defaultMessage: 'Add a song' },
  songEmpty: { id: 'app.sml.smartlinks.editor.picker.song.empty', defaultMessage: 'Your Catalog has no song yet.' },
  back: { id: 'app.sml.smartlinks.editor.picker.back', defaultMessage: 'Back to the blocks' },
});
